/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: dotM4jJPGxS5
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import ButtonPrimary from "../../ButtonPrimary"; // plasmic-import: cGXW91A7jag-/component
import InputFormShell from "../../InputFormShell"; // plasmic-import: mqAYXqPyOASe/component
import ButtonNav from "../../ButtonNav"; // plasmic-import: T4X2Gn8dCIuz/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicNativeContainer.module.css"; // plasmic-import: dotM4jJPGxS5/css
import image8KTo8Rg8U39Nh from "./images/image8.svg"; // plasmic-import: KTo8rg8u39NH/picture

createPlasmicElementProxy;

export const PlasmicNativeContainer__VariantProps = new Array(
  "container",
  "showFormStatus",
  "showFormErrorStatus"
);

export const PlasmicNativeContainer__ArgProps = new Array(
  "showHeader",
  "formHeader",
  "showHelperText",
  "onContainerChange",
  "children",
  "formWrapper",
  "text2",
  "buttonsWrapper",
  "text",
  "infotextWrapper2"
);

const $$ = {};

function PlasmicNativeContainer__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          showHeader: true,
          formHeader: "formTitle.",
          showHelperText: true
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "container",
        type: "writable",
        variableType: "variant",
        valueProp: "container",
        onChangeProp: "onContainerChange"
      },
      {
        path: "showFormStatus",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.showFormStatus
      },
      {
        path: "showFormErrorStatus",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.showFormErrorStatus
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootcontainer_withForm]: hasVariant(
            $state,
            "container",
            "withForm"
          ),
          [sty.rootcontainer_withText]: hasVariant(
            $state,
            "container",
            "withText"
          ),
          [sty.rootshowFormErrorStatus]: hasVariant(
            $state,
            "showFormErrorStatus",
            "showFormErrorStatus"
          ),
          [sty.rootshowFormStatus]: hasVariant(
            $state,
            "showFormStatus",
            "showFormStatus"
          )
        }
      )}
    >
      <div
        data-plasmic-name={"slotOnboardingStep"}
        data-plasmic-override={overrides.slotOnboardingStep}
        className={classNames(projectcss.all, sty.slotOnboardingStep, {
          [sty.slotOnboardingStepcontainer_withForm]: hasVariant(
            $state,
            "container",
            "withForm"
          ),
          [sty.slotOnboardingStepcontainer_withStatus]: hasVariant(
            $state,
            "container",
            "withStatus"
          ),
          [sty.slotOnboardingStepcontainer_withTextAndButtons]: hasVariant(
            $state,
            "container",
            "withTextAndButtons"
          ),
          [sty.slotOnboardingStepcontainer_withText]: hasVariant(
            $state,
            "container",
            "withText"
          ),
          [sty.slotOnboardingStepshowFormErrorStatus]: hasVariant(
            $state,
            "showFormErrorStatus",
            "showFormErrorStatus"
          ),
          [sty.slotOnboardingStepshowFormStatus]: hasVariant(
            $state,
            "showFormStatus",
            "showFormStatus"
          )
        })}
      >
        {(
          hasVariant($state, "showFormErrorStatus", "showFormErrorStatus")
            ? true
            : hasVariant($state, "showFormStatus", "showFormStatus")
              ? true
              : hasVariant($state, "container", "withTextAndButtons")
                ? true
                : (() => {
                    try {
                      return $props.showHeader;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return true;
                      }
                      throw e;
                    }
                  })()
        ) ? (
          <div
            data-plasmic-name={"hederWrapper"}
            data-plasmic-override={overrides.hederWrapper}
            className={classNames(projectcss.all, sty.hederWrapper, {
              [sty.hederWrappercontainer_withForm]: hasVariant(
                $state,
                "container",
                "withForm"
              ),
              [sty.hederWrappercontainer_withTextAndButtons]: hasVariant(
                $state,
                "container",
                "withTextAndButtons"
              ),
              [sty.hederWrappercontainer_withText]: hasVariant(
                $state,
                "container",
                "withText"
              ),
              [sty.hederWrappershowFormErrorStatus]: hasVariant(
                $state,
                "showFormErrorStatus",
                "showFormErrorStatus"
              ),
              [sty.hederWrappershowFormStatus]: hasVariant(
                $state,
                "showFormStatus",
                "showFormStatus"
              )
            })}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text___4FIpJ,
                {
                  [sty.textcontainer_withForm___4FIpJuWHj6]: hasVariant(
                    $state,
                    "container",
                    "withForm"
                  ),
                  [sty.textshowFormErrorStatus___4FIpJqc0DG]: hasVariant(
                    $state,
                    "showFormErrorStatus",
                    "showFormErrorStatus"
                  )
                }
              )}
            >
              <React.Fragment>
                {(() => {
                  try {
                    return $props.formHeader;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return "one step.";
                    }
                    throw e;
                  }
                })()}
              </React.Fragment>
            </div>
          </div>
        ) : null}
        {(
          hasVariant($state, "showFormStatus", "showFormStatus")
            ? true
            : hasVariant($state, "container", "withTextAndButtons")
              ? true
              : false
        ) ? (
          <div
            data-plasmic-name={"statusWrapper"}
            data-plasmic-override={overrides.statusWrapper}
            className={classNames(projectcss.all, sty.statusWrapper, {
              [sty.statusWrappercontainer_withForm]: hasVariant(
                $state,
                "container",
                "withForm"
              ),
              [sty.statusWrappercontainer_withTextAndButtons]: hasVariant(
                $state,
                "container",
                "withTextAndButtons"
              ),
              [sty.statusWrappercontainer_withText]: hasVariant(
                $state,
                "container",
                "withText"
              ),
              [sty.statusWrappershowFormStatus]: hasVariant(
                $state,
                "showFormStatus",
                "showFormStatus"
              )
            })}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__m7CCx
              )}
            >
              {"success! something something"}
            </div>
          </div>
        ) : null}
        {(
          hasVariant($state, "showFormErrorStatus", "showFormErrorStatus")
            ? true
            : hasVariant($state, "showFormStatus", "showFormStatus")
              ? true
              : hasVariant($state, "container", "withTextAndButtons")
                ? true
                : false
        ) ? (
          <div
            data-plasmic-name={"errorStatusWrapper"}
            data-plasmic-override={overrides.errorStatusWrapper}
            className={classNames(projectcss.all, sty.errorStatusWrapper, {
              [sty.errorStatusWrappercontainer_withForm]: hasVariant(
                $state,
                "container",
                "withForm"
              ),
              [sty.errorStatusWrappercontainer_withTextAndButtons]: hasVariant(
                $state,
                "container",
                "withTextAndButtons"
              ),
              [sty.errorStatusWrappercontainer_withText]: hasVariant(
                $state,
                "container",
                "withText"
              ),
              [sty.errorStatusWrappershowFormErrorStatus]: hasVariant(
                $state,
                "showFormErrorStatus",
                "showFormErrorStatus"
              ),
              [sty.errorStatusWrappershowFormStatus]: hasVariant(
                $state,
                "showFormStatus",
                "showFormStatus"
              )
            })}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__f26N1
              )}
            >
              <React.Fragment>
                <React.Fragment>{"oops, "}</React.Fragment>
                <span
                  className={
                    "plasmic_default__all plasmic_default__span plasmic_default__span__fRuRb"
                  }
                  style={{ color: "var(--token-a-Udwe8AHXLu)" }}
                >
                  {"something went wrong."}
                </span>
              </React.Fragment>
            </div>
            <div
              className={classNames(projectcss.all, sty.freeBox__uaA52, {
                [sty.freeBoxshowFormErrorStatus__uaA52Qc0DG]: hasVariant(
                  $state,
                  "showFormErrorStatus",
                  "showFormErrorStatus"
                )
              })}
            >
              {renderPlasmicSlot({
                defaultContents: (
                  <ButtonPrimary
                    color={"brand"}
                    content={"try again"}
                    size={"medium"}
                    ststus={"normal"}
                    type={"button"}
                  />
                ),

                value: args.children
              })}
            </div>
          </div>
        ) : null}
        <div
          className={classNames(projectcss.all, sty.freeBox__vYtIi, {
            [sty.freeBoxcontainer_withForm__vYtIiuWHj6]: hasVariant(
              $state,
              "container",
              "withForm"
            ),
            [sty.freeBoxcontainer_withStatus__vYtIipjkes]: hasVariant(
              $state,
              "container",
              "withStatus"
            ),
            [sty.freeBoxcontainer_withTextAndButtons__vYtIiELuS]: hasVariant(
              $state,
              "container",
              "withTextAndButtons"
            ),
            [sty.freeBoxcontainer_withText__vYtIiZIyCm]: hasVariant(
              $state,
              "container",
              "withText"
            ),
            [sty.freeBoxshowFormErrorStatus__vYtIiqc0DG]: hasVariant(
              $state,
              "showFormErrorStatus",
              "showFormErrorStatus"
            ),
            [sty.freeBoxshowFormStatus__vYtIidYzoA]: hasVariant(
              $state,
              "showFormStatus",
              "showFormStatus"
            )
          })}
        >
          <div
            data-plasmic-name={"slotFormWrapper"}
            data-plasmic-override={overrides.slotFormWrapper}
            className={classNames(projectcss.all, sty.slotFormWrapper, {
              [sty.slotFormWrappercontainer_withForm]: hasVariant(
                $state,
                "container",
                "withForm"
              ),
              [sty.slotFormWrappercontainer_withTextAndButtons]: hasVariant(
                $state,
                "container",
                "withTextAndButtons"
              ),
              [sty.slotFormWrappercontainer_withText]: hasVariant(
                $state,
                "container",
                "withText"
              ),
              [sty.slotFormWrappershowFormErrorStatus]: hasVariant(
                $state,
                "showFormErrorStatus",
                "showFormErrorStatus"
              )
            })}
          >
            {(hasVariant($state, "container", "withText") ? false : true)
              ? renderPlasmicSlot({
                  defaultContents: (
                    <InputFormShell
                      actionsSlot={
                        <ButtonPrimary
                          className={classNames(
                            "__wab_instance",
                            sty.buttonPrimary__hPe9Z
                          )}
                          type={"button"}
                        />
                      }
                      className={classNames(
                        "__wab_instance",
                        sty.inputFormShell__gYahv
                      )}
                    />
                  ),

                  value: args.formWrapper
                })
              : null}
          </div>
          <div
            className={classNames(projectcss.all, sty.freeBox__uy8Hh, {
              [sty.freeBoxcontainer_withForm__uy8HHuWHj6]: hasVariant(
                $state,
                "container",
                "withForm"
              ),
              [sty.freeBoxcontainer_withTextAndButtons__uy8HhELuS]: hasVariant(
                $state,
                "container",
                "withTextAndButtons"
              ),
              [sty.freeBoxshowFormErrorStatus__uy8HHqc0DG]: hasVariant(
                $state,
                "showFormErrorStatus",
                "showFormErrorStatus"
              )
            })}
          >
            {renderPlasmicSlot({
              defaultContents: null,
              value: args.text2
            })}
          </div>
          <div
            data-plasmic-name={"slotButtonsWrapper"}
            data-plasmic-override={overrides.slotButtonsWrapper}
            className={classNames(projectcss.all, sty.slotButtonsWrapper, {
              [sty.slotButtonsWrappercontainer_withForm]: hasVariant(
                $state,
                "container",
                "withForm"
              ),
              [sty.slotButtonsWrappercontainer_withTextAndButtons]: hasVariant(
                $state,
                "container",
                "withTextAndButtons"
              ),
              [sty.slotButtonsWrappercontainer_withText]: hasVariant(
                $state,
                "container",
                "withText"
              )
            })}
          >
            {renderPlasmicSlot({
              defaultContents: null,
              value: args.buttonsWrapper
            })}
          </div>
          <div
            className={classNames(projectcss.all, sty.freeBox__v6AdD, {
              [sty.freeBoxcontainer_withText__v6AdDzIyCm]: hasVariant(
                $state,
                "container",
                "withText"
              )
            })}
          >
            {renderPlasmicSlot({
              defaultContents: null,
              value: args.text
            })}
          </div>
        </div>
        {(
          hasVariant($state, "showFormErrorStatus", "showFormErrorStatus")
            ? true
            : hasVariant($state, "showFormStatus", "showFormStatus")
              ? true
              : hasVariant($state, "container", "withText")
                ? true
                : hasVariant($state, "container", "withTextAndButtons")
                  ? true
                  : (() => {
                      try {
                        return $props.showHelperText;
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return true;
                        }
                        throw e;
                      }
                    })()
        ) ? (
          <div
            data-plasmic-name={"infotextWrapper"}
            data-plasmic-override={overrides.infotextWrapper}
            className={classNames(projectcss.all, sty.infotextWrapper, {
              [sty.infotextWrappercontainer_withTextAndButtons]: hasVariant(
                $state,
                "container",
                "withTextAndButtons"
              ),
              [sty.infotextWrappercontainer_withText]: hasVariant(
                $state,
                "container",
                "withText"
              ),
              [sty.infotextWrappershowFormErrorStatus]: hasVariant(
                $state,
                "showFormErrorStatus",
                "showFormErrorStatus"
              ),
              [sty.infotextWrappershowFormStatus]: hasVariant(
                $state,
                "showFormStatus",
                "showFormStatus"
              )
            })}
          >
            {renderPlasmicSlot({
              defaultContents: (
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___6ZA8G
                  )}
                >
                  {"Helper text."}
                </div>
              ),

              value: args.infotextWrapper2
            })}
          </div>
        ) : null}
      </div>
      <div
        data-plasmic-name={"termWrapper"}
        data-plasmic-override={overrides.termWrapper}
        className={classNames(projectcss.all, sty.termWrapper, {
          [sty.termWrappercontainer_withText]: hasVariant(
            $state,
            "container",
            "withText"
          )
        })}
      >
        <div
          className={classNames(projectcss.all, sty.freeBox__wjFuj, {
            [sty.freeBoxcontainer_withText__wjFujzIyCm]: hasVariant(
              $state,
              "container",
              "withText"
            )
          })}
        >
          <div
            data-plasmic-name={"termSlotWrapper"}
            data-plasmic-override={overrides.termSlotWrapper}
            className={classNames(projectcss.all, sty.termSlotWrapper, {
              [sty.termSlotWrappercontainer_withForm]: hasVariant(
                $state,
                "container",
                "withForm"
              )
            })}
          >
            <div
              className={classNames(projectcss.all, sty.freeBox__g3G8N, {
                [sty.freeBoxcontainer_withForm__g3G8NuWHj6]: hasVariant(
                  $state,
                  "container",
                  "withForm"
                )
              })}
            >
              <ButtonNav
                className={classNames("__wab_instance", sty.buttonNav___2MnkI)}
              />

              <ButtonNav
                className={classNames("__wab_instance", sty.buttonNav__ts1Y1)}
              />

              <ButtonNav
                className={classNames("__wab_instance", sty.buttonNav___9Dplm)}
                iconForButton={
                  <PlasmicImg__
                    data-plasmic-name={"img"}
                    data-plasmic-override={overrides.img}
                    alt={""}
                    className={classNames(sty.img)}
                    displayHeight={"100%"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"none"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"100%"}
                    loading={"lazy"}
                    src={{
                      src: image8KTo8Rg8U39Nh,
                      fullWidth: 20,
                      fullHeight: 20,
                      aspectRatio: undefined
                    }}
                  />
                }
                shape={"globalRounding"}
                status={"normal"}
              />
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__ec3Ji
              )}
            >
              {
                "Last updated JULY 25, 2025.\n\n\nLorem ipsum dolor sit amet consectetur. Consequat in eget tellus lacinia varius arcu at lacus. Vitae gravida eu sed ut. Placerat sagittis vitae purus lorem dignissim semper donec commodo egestas. Cras dui ac metus enim semper dolor sed semper facilisis. \n\n\nFacilisi vel dictumst ut mi magna morbi pellentesque sed. Purus interdum nec urna at nunc. Tellus tellus nec orci praesent lectus elementum eget tortor laoreet. Consequat quam consectetur aliquet auctor nascetur nisi rhoncus nisl. Mi tellus ac arcu mauris aenean ullamcorper. Placerat placerat vitae nibh lacus. Tincidunt consequat commodo id sagittis. Risus nec et arcu amet ut lectus. Mauris convallis vitae commodo ipsum accumsan ac consectetur odio et. Ac aliquam scelerisque tellus risus mauris risus a.\n"
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "slotOnboardingStep",
    "hederWrapper",
    "statusWrapper",
    "errorStatusWrapper",
    "slotFormWrapper",
    "slotButtonsWrapper",
    "infotextWrapper",
    "termWrapper",
    "termSlotWrapper",
    "img"
  ],

  slotOnboardingStep: [
    "slotOnboardingStep",
    "hederWrapper",
    "statusWrapper",
    "errorStatusWrapper",
    "slotFormWrapper",
    "slotButtonsWrapper",
    "infotextWrapper"
  ],

  hederWrapper: ["hederWrapper"],
  statusWrapper: ["statusWrapper"],
  errorStatusWrapper: ["errorStatusWrapper"],
  slotFormWrapper: ["slotFormWrapper"],
  slotButtonsWrapper: ["slotButtonsWrapper"],
  infotextWrapper: ["infotextWrapper"],
  termWrapper: ["termWrapper", "termSlotWrapper", "img"],
  termSlotWrapper: ["termSlotWrapper", "img"],
  img: ["img"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicNativeContainer__ArgProps,
          internalVariantPropNames: PlasmicNativeContainer__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicNativeContainer__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicNativeContainer";
  } else {
    func.displayName = `PlasmicNativeContainer.${nodeName}`;
  }
  return func;
}

export const PlasmicNativeContainer = Object.assign(
  // Top-level PlasmicNativeContainer renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    slotOnboardingStep: makeNodeComponent("slotOnboardingStep"),
    hederWrapper: makeNodeComponent("hederWrapper"),
    statusWrapper: makeNodeComponent("statusWrapper"),
    errorStatusWrapper: makeNodeComponent("errorStatusWrapper"),
    slotFormWrapper: makeNodeComponent("slotFormWrapper"),
    slotButtonsWrapper: makeNodeComponent("slotButtonsWrapper"),
    infotextWrapper: makeNodeComponent("infotextWrapper"),
    termWrapper: makeNodeComponent("termWrapper"),
    termSlotWrapper: makeNodeComponent("termSlotWrapper"),
    img: makeNodeComponent("img"),
    // Metadata about props expected for PlasmicNativeContainer
    internalVariantProps: PlasmicNativeContainer__VariantProps,
    internalArgProps: PlasmicNativeContainer__ArgProps
  }
);

export default PlasmicNativeContainer;
/* prettier-ignore-end */
